import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';
import {
  fetchDenominations,
  fetchCurrentAbilities,
  fetchClientConfig,
  resetPinPad,
} from '../../utils/api/client';
import { getAccessToken, getPosApiUrl } from '../../utils/state';

import {
  fetchDenominationsError,
  fetchDenominationsSuccess,
  FETCH_DENOMINATIONS,
  FETCH_CURRENT_ABILITIES,
  fetchCurrentAbilitiesSuccess,
  fetchCurrentAbilitiesError,
  FETCH_CLIENT_CONFIG,
  fetchClientConfigSuccess,
  fetchClientConfigError,
  RESET_PIN_PAD,
  resetPinPadSuccess,
  resetPinPadError,
  replaceSharedAlerts,
  genericErrorMessage,
} from '../shared';

const fetchDenominationsParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
});

const fetchClientConfigParams = (state, action) => ({
  url: getPosApiUrl(state),
  clientId: action.payload,
  token: getAccessToken(state),
});

const fetchCurrentAbilitiesParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
});

const resetPinPadParams = (state, action) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
  terminalId: action.payload.terminalId,
  method: 'POST',
});

export const fetchClientConfigEpic = (action$, state$) =>
  action$.ofType(FETCH_CLIENT_CONFIG).pipe(
    RxOp.flatMap((action) =>
      Rx.from(
        fetchClientConfig(fetchClientConfigParams(state$.value, action)),
      ).pipe(
        RxOp.flatMap((response) =>
          Rx.of(fetchClientConfigSuccess(response.data)),
        ),
        RxOp.catchError((err) =>
          Rx.of(
            fetchClientConfigError(err.message),
            replaceSharedAlerts(
              genericErrorMessage(err, 'Fetch Client Configuration Error'),
            ),
          ),
        ),
      ),
    ),
  );

export const fetchCurrentAbilitiesEpic = (action$, state$) =>
  action$.ofType(FETCH_CURRENT_ABILITIES).pipe(
    RxOp.flatMap(() =>
      Rx.from(
        fetchCurrentAbilities(fetchCurrentAbilitiesParams(state$.value)),
      ).pipe(
        RxOp.flatMap((response) =>
          Rx.of(fetchCurrentAbilitiesSuccess(response.data)),
        ),
        RxOp.catchError((err) =>
          Rx.of(
            fetchCurrentAbilitiesError(err.message),
            replaceSharedAlerts(
              genericErrorMessage(err, 'Fetch Abilities Error'),
            ),
          ),
        ),
      ),
    ),
  );

export const fetchDenominationsEpic = (action$, state$) =>
  action$.ofType(FETCH_DENOMINATIONS).pipe(
    RxOp.flatMap(() =>
      Rx.from(fetchDenominations(fetchDenominationsParams(state$.value))).pipe(
        RxOp.flatMap((response) =>
          Rx.of(fetchDenominationsSuccess(response.data)),
        ),
        RxOp.catchError((err) =>
          Rx.of(
            fetchDenominationsError(err.message),
            replaceSharedAlerts(
              genericErrorMessage(err, 'Fetch Denominations Error'),
            ),
          ),
        ),
      ),
    ),
  );

export const resetPinPadEpic = (action$, state$) =>
  action$.ofType(RESET_PIN_PAD).pipe(
    RxOp.flatMap((action) =>
      Rx.from(resetPinPad(resetPinPadParams(state$.value, action))).pipe(
        RxOp.flatMap((response) => Rx.of(resetPinPadSuccess(response.data))),
        RxOp.catchError((err) => Rx.of(resetPinPadError(err))),
      ),
    ),
  );
